import { createContext } from 'react'

export const ReplyToMessageContext = createContext<{
    canReplyInline: boolean
    canReplyInThread: boolean
    setReplyToEventId?: (threadId: string | null) => void
    replyToEventId?: string | null
    replyMode: 'inline' | 'thread'
    setReplyMode: (mode: 'inline' | 'thread') => void
    resetReplyToMessageContext: () => void
}>({
    canReplyInline: false,
    canReplyInThread: false,
    replyMode: 'inline',
    setReplyMode: () => {},
    resetReplyToMessageContext: () => {},
})
